import { required } from "vuelidate/lib/validators";

export class Profile {
    constructor(initObjectParams) {
        this.id = null;
        this.firstName = null;
        this.lastName = null;
        this.secondName = null;
        this.phone = null;
        this.position = null;
    }

    static get modelName() {
        return 'Profile'
    }

    static get validations() {
        return {
            firstName: { },
            secondName: {  },
            lastName: { },
            phone: {  },
            position: { }
        }
    }

    static get validationFieldLabels() {
        return {
            firstName: 'Имя',
            secondName: 'Отчество',
            lastName: 'Фамилия',
            phone: 'Телефон',
            position: 'Должность'
        }
    }

    static get mapping() {
        return {
            firstName: 'first_name',
            secondName: 'second_name',
            lastName: 'last_name',
        }
    }

    static get label() {
        return 'Профиль'
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.id = data['id'];
        this.firstName = data['first_name'];
        this.lastName = data['last_name'];
        this.secondName = data['second_name'];
        this.phone = data['phone'];
        this.position = data['position'];
    }
}
